import React, { useState, useEffect, useRef } from "react";
import { Table, Tooltip, Spin, Checkbox, Space, message, Input, DatePicker, Select, Button } from "antd";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { agreementOptions, formatIndianDate } from "../../utils/Constant";
import CustomSearch from "../../components/search/CustomSearch";
import { capitalizeAndRemoveUnderscores, downloadFile, limitWords, toTitleCase } from "../../utils/utils";
import ViewDetail from "../../components/button/ViewDetail";
import EditorSwitch from "../../components/editorSwitch";
import Pnation from "../../components/Pagination/pagination";
import Papa from 'papaparse';
import { DownloadOutlined, MailOutlined, CloseOutlined, FilterOutlined } from '@ant-design/icons'; // Import the download icon
import MotionIconButton from "../../components/icons/MotionIcon";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import { useTheme } from "../../utils/themeToggle/theme";


const BoldPlusIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="10" y="3" width="4" height="18" rx="1" />
    <rect x="3" y="10" width="18" height="4" rx="1" />
  </svg>
);

const btnStyle = {
  backgroundColor: '#36A34A',
  color: 'white',
  padding: '8px 16px',  // Adjust padding for smaller button
  fontSize: '14px',      // Adjust font size to match previous size,
  marginTop: '30px',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer'
}

function FreshRequest() {
  const [isLoading, setIsloading] = useState(false);
  let [request, setRequest] = useState(false);
  const params = useParams();
  const navigate = useNavigate()
  const location = useLocation();
  const data = location?.state?.label;
  const isFromAnaltticData = location?.state?.status ? true : false;
  const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '', is_active: "True", status: params?.status?.toUpperCase(), is_editor: false });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const state = location.state;
  const companyId = localStorage.getItem("companyId");
  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const { darkMode, toggleTheme } = useTheme();

  const [searchFields, setSearchFields] = useState({
    first_name: '',
    created_at: null,
    agreement_type: '',
    name_of_client: '',
    nature: '',
    status: '',
    effective_date: null,
    execution_date: null,
    tenure: '',
    termination_notice: '',
    invoice_frequency: '',
    invoice_date: null,
    credit_term: '',
    contract_currency_value: '',
    contract_currency: '',
    value: '',
    custom_field: '',
    product_name: ''
  });
  const { Option } = Select;

  const childRef = useRef();
  const [listingUrl, setListingUrl] = useState('')
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const NatureOfPaymentType = [
    { value: "customer", label: "Customer" },
    { value: "vendor", label: "Vendor" },
    { value: "partnership", label: "Partnership" },
  ];

  const handleDataFromChild = () => {
    return childRef.current?.getPayload(); // Get data from the child component using ref
  };
  const getSearchFilters = () => {
    return Object.entries(searchFields)
      .filter(([_, value]) => value !== null && value !== '')
      .map(([key, value]) => ({
        key,
        value: value?.format ? value.format('DD-MM-YYYY') : value,
      }));
  };
  const handleAdvanceSearch = async () => {
    const filters = getSearchFilters();
    const payload = {
      search_keyword: searchKeyword.search_keyword,
      search_filters: filters,
      is_active: "True",
      is_editor: searchKeyword.is_editor || false,
      page_number: 1,
      page_size: 10,
    };

    setIsloading(true);
    try {
      const res = await axiosInstance.post("/contract/search_spcial/", payload);
      setRequest(res?.data?.results || []);
      setListingUrl("");
      setIsFilterOpen(false); // close the filter
    } catch (error) {
      message.error("Failed to fetch search results");
      console.error(error);
    } finally {
      setIsloading(false);
    }
  };

  const handleViewDetails = async (record) => {
    if (!record.is_read) {
      await axiosInstance.put(`/contract/update-read-or-unread-agreement/`, {
        agreement_ids: [record.id],
        read_status: true,
        company_id: companyId || comp_id,
      });

    } else {
    }
    navigate(
      companyId
        ? `/admin/company/${companyId}/contracts/${record.id}`
        : `/admin/contracts/${record.id}`
    );

  };
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      // Select all rows
      const allRowKeys = request?.map((item) => item.id);
      setSelectedRowKeys(allRowKeys);
    } else {
      // Deselect all rows
      setSelectedRowKeys([]);
    }
  };
  const handleIconClick = async () => {
    try {
      const response = await axiosInstance.put(`/contract/update-read-or-unread-agreement/`, {
        agreement_ids: selectedRowKeys,
        read_status: false,
        company_id: companyId || comp_id,
      });

      if (response.status === 200) {
        setSearchKeyword({ ...searchKeyword })
        setSelectedRowKeys([]);
      }
    } catch (error) {
      setSelectedRowKeys([]);
    }
  };
  const columns = [
    {
      title: (
        <Checkbox
          indeterminate={
            selectedRowKeys.length > 0 &&
            selectedRowKeys.length < request.length
          }
          checked={selectedRowKeys.length === request.length}
          onChange={handleSelectAllChange}
          onClick={(e) => e.stopPropagation()}
        />
      ),
      dataIndex: "checkbox",
      width: 15,
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.id)}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRowKeys([...selectedRowKeys, record.id]);
            } else {
              setSelectedRowKeys(
                selectedRowKeys.filter((key) => key !== record.id)
              );
            }
          }}
        />
      ),
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      width: 50,
      ellipsis: true,
      render: (userName, record) => {
        return (
          <span
            style={{
              fontWeight: record.is_read ? "normal" : "bold",
              color: "black",
            }}
          >
            {userName}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Date of Raising (dd-mm-yyyy)">
          Date of Raising <br />
          (dd-mm-yyyy)
        </Tooltip>
      ),
      dataIndex: "created_at",
      key: "created_at",
      width: 70,
      ellipsis: true,
      render: (date, record) => {
        return (
          <span style={{
            fontWeight: record.is_read ? "normal" : "bold",
            color: "black",
          }}>
            {formatIndianDate(date)}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Agreement Type">
          Agreement Type
        </Tooltip>
      ),
      dataIndex: "agreement_type",
      width: 70,
      ellipsis: true,
      render: (text, record) => {
        return (
          <Tooltip title={text}>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontWeight: record.is_read ? "normal" : "bold",
                color: "black", // Change color if unauthorized changes exist
              }}
            >
              {limitWords(text, 12)}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Partner Name">
          Partner Name
        </Tooltip>
      ),
      dataIndex: "name_of_client",
      width: 80,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span style={{ fontWeight: record.is_read ? "normal" : "bold", color: "black" }}>
            {text && text.charAt(0).toUpperCase() + text.slice(1)}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Nature">
          Nature
        </Tooltip>
      ),
      dataIndex: "nature",
      width: 60,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span style={{ fontWeight: record.is_read ? "normal" : "bold", color: "black" }}>
            {text && text.charAt(0).toUpperCase() + text.slice(1)}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Status">
          Status
        </Tooltip>
      ),
      dataIndex: "status",
      width: 70,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span style={{ fontWeight: record.is_read ? "normal" : "bold", color: "black" }}>
            {capitalizeAndRemoveUnderscores(text)}
          </span>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="Remarks(if any)">
          <span>Remarks(if any)</span>
        </Tooltip>
      ),
      dataIndex: "remarks",
      width: 70,
      ellipsis: true,
      render: (text, record) => {
        return (
          <Tooltip title={text}>
            <div
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontWeight: record.is_read ? "normal" : "bold",
                color: "black", // Change color if unauthorized changes exist
              }}
            >
              {limitWords(text, 6)}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: (
        <Tooltip className="whitespace-nowrap" title="View details">
          View details
        </Tooltip>
      ),
      dataIndex: "first_name",
      key: "first_name",
      width: 70,
      ellipsis: true,
      render: (text, record) => <ViewDetail />,
    },
  ];


  const handleSearch = (value) => {
    setSearchKeyword((val) => {
      val.search_keyword = value;
      return { ...val }
    })

  };

  const handleSwitchChange = (checked) => {
    setSearchKeyword((val) => {
      const updatedVal = { ...val, is_editor: checked };

      if (checked) {
        updatedVal.excuted = "Executed";
      } else {
        delete updatedVal.excuted;
      }

      return updatedVal;
    });
  };
  const getData = (data) => {
    setRequest(data);
  }
  const onPeding = (val) => {
    setIsloading(val)
  }
  const handleDownloadAll = () => {
    if (!request) {
      return false;
    }
    const csvData = request?.map(contract => ({
      "User Name": contract.user_name,
      "Date of Raising": formatIndianDate(contract.created_at),
      "Agreement Type": contract.agreement_type,
      "Partner Name": contract.name_of_client,
      "Nature": contract.nature,
      "Status": capitalizeAndRemoveUnderscores(contract.status),
      "Remarks": contract.remarks,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "contracts.csv";
    link.click();
    message.success("contracts details downloaded successfully")
  };
  const handelAgrDwn = async () => {
    const payload = {
      ...handleDataFromChild(),
      ...searchKeyword
    }
    try {
      const response = await axiosInstance.post(`/Download-all-agreement/`, payload);
      downloadFile(response.data.agreement_file_url, "downloaded_Agreement");
      message.success("agreement downloaded successfully")
    } catch (error) {
      console.log(error)
    }
  }
  console.log(location.state)

  useEffect(() => {
    if (data) {
      setListingUrl('/contract/get/')
      setSearchKeyword({
        status: 'EXECUTED',
        month: data.split(' ')[0],
        year: data.split(' ')[1],
        is_active: "True",
        is_editor: false,
        company_id: localStorage.getItem("companyId") || comp_id
      })
    } else if (!!isFromAnaltticData && (location?.state?.product_name || location?.state?.payment_type)) {
      setListingUrl('/filter-agreements/');
      console.log(location, location?.state?.product_name, location?.state?.payment_type, 'abadat')
      setSearchKeyword({
        status: 'EXECUTED',
        payment_type: location?.state?.payment_type,
        product: location?.state?.product_name,
        is_editor: false,
        search_keyword: '',
        company_id: localStorage.getItem("companyId") || comp_id
      })
    }
    else if (state?.user_id && state?.status) {
      setListingUrl('/contracts/user-filtered/');
      setSearchKeyword({
        user_id: state.user_id,
        status: state.status,
        search_keyword: ``,
        is_active: 'True',
        is_editor: false,
        company_id: localStorage.getItem("companyId") || comp_id
      });
    }
    else {
      setListingUrl('/contract/get/')
      setSearchKeyword({ search_keyword: '', search_filters: getSearchFilters(), is_active: "True", status: params?.status?.toUpperCase(), is_editor: false, company_id: localStorage.getItem("companyId") || comp_id })
    }
  }, [data, location]);

  return (

    <div className="my-[-3px]">
      <div className="mb-1 flex flex-row justify-between ">
        <div className="flex  items-center w-full">
          <h1 className="font-semibold text-[17px] dark:text-white"> Contracts </h1>
          <div className="ml-4 mr-2 flex justify-center items-center">
            {selectedRowKeys.length > 0 ? (
              <Tooltip title="Unread">
                <MailOutlined size={"small"}
                  className="text-xl transform pr-2 dark:text-white hover:scale-120 transition-transform duration-300 cursor-pointer"
                  onClick={handleIconClick}
                />
              </Tooltip>
            ) : (
              <div className="pr-7"></div>

            )}
          </div>
          <div className=" text-black relative  flex justify-right">
            <div className="relative mr-6 md:flex justify-between items-center gap-4">
              <div className="flex items-center gap-1">
                <CustomSearch onSearch={handleSearch} />
                <Tooltip title="Advanced Search Option">
                  <Button
                    type="primary"
                    icon={<FilterOutlined />}
                    onClick={() => setIsFilterOpen(prev => !prev)}
                  />
                </Tooltip>
              </div>

              {isFilterOpen && (
                <div className="w-[700px] p-4 border-[1.4px] shadow-custom-shadow border-[#bca5fa] rounded-md bg-[#EDE9FE] mt-4 absolute top-4 left-0 z-[999]">
                  <CloseOutlined onClick={() => setIsFilterOpen(false)} style={{ fontSize: '16px', color: 'red', float: "right" }} />

                  <div className="grid grid-cols-4 gap-3">
                    {/* 
                    <div className="text-xs">
                      <label className="block mb-1">User Name</label>
                      <Input
                        size="small"
                        placeholder="User Name"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.first_name}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, first_name: e.target.value }))}
                      />
                    </div> */}

                    <div className="text-xs">
                      <label className="block mb-1">Date of Raising</label>
                      <DatePicker
                        size="small"
                        className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.created_at}
                        onChange={(date) => setSearchFields(prev => ({ ...prev, created_at: date }))}
                      />
                    </div>
                    <div className="text-xs">
                      <label className="block mb-1">Partner Name</label>
                      <Input
                        size="small"

                        placeholder="Partner Name"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.name_of_client}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, name_of_client: e.target.value }))}
                      />
                    </div>

                    <div className="text-xs only-bottom-border-select col-span-2">
                      <label className="block mb-1">Agreement Type</label>
                      <Select
                        size="small"
                        placeholder="Select Agreement Type"
                        value={searchFields.agreement_type}
                        onChange={(value) =>
                          setSearchFields((prev) => ({ ...prev, agreement_type: value }))
                        }
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        className="w-full custom-select-border"
                      >
                        {agreementOptions.map((option) => (
                          <Option key={option.value} value={option.value} label={option.label}>
                            {option.label}
                          </Option>
                        ))}
                      </Select>
                    </div>


                    <div className="text-xs col-span-2">
                      <label className="block mb-1">Effective Date</label>
                      <DatePicker
                        size="small"
                        className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.effective_date}
                        onChange={(date) => setSearchFields(prev => ({ ...prev, effective_date: date }))}
                      />
                    </div>

                    <div className="text-xs col-span-2">
                      <label className="block mb-1">Execution Date</label>
                      <DatePicker
                        size="small"
                        className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.execution_date}
                        onChange={(date) => setSearchFields(prev => ({ ...prev, execution_date: date }))}
                      />
                    </div>
                    {/* <div className="text-xs">
                      <label className="block mb-1">Tenure</label>
                      <Input
                        size="small"
                        placeholder="Tenure"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.tenure}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, tenure: e.target.value }))}
                      />
                    </div> */}

                    <div className="text-xs">

                      <label className="block mb-1">Termination Notice</label>
                      <Input
                        size="small"
                        placeholder="Termination Notice"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.termination_notice}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, termination_notice: e.target.value }))}
                      />
                    </div>
                    <div className="text-xs only-bottom-border-select col-span-2">
                      <label className="block mb-1">Status</label>
                      <Select
                        size="small"
                        placeholder="Select Status"
                        className="w-full"
                        value={searchFields.status}
                        onChange={(value) => setSearchFields(prev => ({ ...prev, status: value }))}
                      >
                        <Select.Option value="FRESH_REQUEST">Fresh Request</Select.Option>
                        <Select.Option value="UNDER_NEGOTIATION">Under Negotiation</Select.Option>
                        <Select.Option value="UNDER_EXECUTION">Under Execution</Select.Option>
                        <Select.Option value="EXECUTED">Executed</Select.Option>
                        <Select.Option value="TRANSACTION_CLOSED">Transaction Closed</Select.Option>
                      </Select>
                    </div>
                    <div className="text-xs only-bottom-border-select">
                      <label className="block mb-1 font-medium">Nature</label>
                      <Select
                        size="small"
                        placeholder="Select Nature"
                        className="w-full"
                        value={searchFields.nature}
                        onChange={(value) => setSearchFields(prev => ({ ...prev, nature: value }))}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                      >
                        {NatureOfPaymentType.map((option) => (
                          <Select.Option key={option.value} value={option.value} label={option.label}>
                            {option.label}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                    <div className="text-xs">
                      <label className="block mb-1">Product Name</label>
                      <Input
                        size="small"
                        placeholder="Product Name"
                        className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.product_name}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, product_name: e.target.value }))}
                      />
                    </div>
                    <div className="text-xs">
                      <label className="block mb-1">Invoice Raising Date</label>
                      <Input
                        size="small"
                        placeholder="Invoice Raising Date"
                        className="w-full border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.invoice_date}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, invoice_date: e.target.value }))}
                      />
                    </div>
                    <div className="text-xs">
                      <label className="block mb-1">Invoice Frequency</label>
                      <Input
                        size="small"
                        placeholder="Invoice Frequency"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.invoice_frequency}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, invoice_frequency: e.target.value }))}
                      />
                    </div>
                    <div className="text-xs">
                      <label className="block mb-1">Contract Currency</label>
                      <Input
                        size="small"
                        placeholder="Contract Currency"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.contract_currency}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, contract_currency: e.target.value }))}
                      />
                    </div>
                    <div className="text-xs">
                      <label className="block mb-1">Currency Value</label>
                      <Input
                        size="small"
                        placeholder="Currency Value"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.contract_currency_value}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, contract_currency_value: e.target.value }))}
                      />
                    </div>
                    <div className="text-xs">
                      <label className="block mb-1">Base Value</label>
                      <Input
                        size="small"
                        placeholder="Base Value"
                        className="border-0 border-b bg-[#EDE9FE] border-gray-400 rounded-none focus:border-b-blue-500 focus:shadow-none"
                        value={searchFields.value}
                        onChange={(e) => setSearchFields(prev => ({ ...prev, value: e.target.value }))}
                      />
                    </div>
                  </div>
                  {/* Footer buttons */}
                  <div className="flex justify-between mt-3">
                    <Button type="primary" onClick={() => {
                      setSearchFields({
                        first_name: '',
                        created_at: null,
                        agreement_type: '',
                        name_of_client: '',
                        nature: '',
                        status: '',
                        effective_date: null,
                        execution_date: null,
                        tenure: '',
                        termination_notice: '',
                        invoice_frequency: '',
                        invoice_date: null,
                        credit_term: '',
                        contract_currency_value: '',
                        contract_currency: '',
                        value: '',
                        custom_field: '',
                        product_name: ''
                      })
                    }
                    }> Clear filter</Button>
                    <Button
                      type="primary"
                      onClick={handleAdvanceSearch}
                    >
                      Search
                    </Button>
                  </div>
                </div>
              )}
              <div className="gap-4 mt-4 md:mt-0">

                {
                  params?.status !== "executed" && params?.status !== "transaction_closed" &&
                  <EditorSwitch initialState={false} state2={'All'} state1={'Editor'} isLoading={isLoading} handleSwitchChange={handleSwitchChange} />
                }
              </div>
            </div>
          </div>
        </div>
        <Link to={
          companyId
            ? `/admin/company/${companyId}/contracts/create_request`
            : `/admin/contracts/create_request`
        }>
          <MotionIconButton tooltip="Raise New Request" icon={<BoldPlusIcon />} onClick={() => { }} />
        </Link>
      </div>

      <div className="border border-gray-300">

        <Spin spinning={isLoading} tip="Loading...">
          <Table
            columns={columns}
            dataSource={request}
            scroll={{ x: 'max-content' }}
            className="text-[8px]  [&_.ant-table-cell]:text-[12px] dark:[&_.ant-table]:text-white dark:[&_.ant-table-cell]:text-white dark:[&_.ant-table-thead>tr>th]:text-white"
            tableLayout="fixed"
            size="small"
            style={{ color: darkMode ? "white" : "black", font: "120px" }}
            pagination={false}
            onRow={(record) => ({
              onClick: () => handleViewDetails(record),
              style: { cursor: "pointer" },
            })}
          />
        </Spin>
      </div>
      {!!listingUrl &&
        (data ? (Object.keys(searchKeyword).length > 4 && <Pnation onPeding={onPeding} onCngPage={getData} url={listingUrl} plod={searchKeyword} itmeName="Contracts" />) :
          isFromAnaltticData ? <Pnation onPeding={onPeding} onCngPage={getData} url={listingUrl} plod={searchKeyword} itmeName="Contracts" /> : <Pnation onPeding={onPeding} onCngPage={getData} url={listingUrl} plod={searchKeyword} itmeName="Contracts" />)
      }
      <div className="flex justify-center items-center gap-4 w-full ">
        <button
          onClick={handleDownloadAll}
          style={btnStyle}
        >
          Download Contracts Details <DownloadOutlined />
        </button>
        <button
          style={btnStyle}
          onClick={handelAgrDwn}
        >
          Download  Contracts Files <DownloadOutlined />
        </button>
      </div>
    </div>

  );
}

export default FreshRequest;
